import { Input } from 'antd';

import styles from './AppInput.module.scss';

const AppInput = ({ className = '', ...restProps }) => (
  <Input className={`${styles.input} ${className}`} {...restProps} />
);

export default AppInput;
